module.exports = __webpack_public_path__ + "lp/img/up-icon-question.8f7fb0a0.svg";